const canal = 'appWeb'
export default canal
